export default "__VITE_ASSET__wGMwrttP__"